const router_modular = [
    {
        path: '/',
        name: 'login',
        component: () => import(/* webpackChunkName: "about" */ '@/views/login.vue')
    },
    {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/index.vue')
    },
    {
        path: '/map',
        name: 'map',
        component: () => import(/* webpackChunkName: "about" */ '@/views/mapIndex.vue')
    },
    {
        path: '/saleDetail',
        name: 'saleDetail',
        component: () => import(/* webpackChunkName: "about" */ '@/views/sale-detail.vue')
    }
]
export default router_modular